/* 布局 */
//前台
import Layout from "@views/layout";

const questionnaireRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
            path: "questionnaire",
            name: "QUESTIONNAIRE",
            meta: {
                title: "调查问卷",
                sort: 1,
            },
            component: () => import("@views/business/questionnaire/index.vue"),
            redirect: {
                name: "QUESTIONNAIRE_LIST",
            },
            children: [
                {
                    path: "list",
                    name: "QUESTIONNAIRE_LIST",
                    meta: {
                        title: "调查问卷",
                        sort: 2,
                        keepAlive: true
                    },
                    component: () => import("@views/business/questionnaire/list.vue"),
                },
                {
                    path: "add",
                    name: "QUESTIONNAIRE_ADD",
                    meta: {
                        title: "新增问卷调查主表",
                        parentPath: '/business/questionnaire/list',
                        operate: true,
                    },
                    component: () => import("@views/business/questionnaire/form.vue"),
                },
                {
                    path: "edit",
                    name: "QUESTIONNAIRE_EDIT",
                    meta: {
                        title: "编辑问卷调查主表",
                        parentPath: '/business/questionnaire/list',
                        operate: true,
                    },
                    component: () => import("@views/business/questionnaire/form.vue"),
                },
                {
                    path: "info",
                    name: "QUESTIONNAIRE_INFO",
                    meta: {
                        title: "问卷详情",
                        parentPath: '/business/questionnaire/list',
                        operate: true,
                    },
                    component: () => import("@views/business/questionnaire/info.vue"),
                },
                {
                    path: "questionnaireanswer",
                    name: "QUESTIONNAIREANWSER_LIST",
                    meta: {
                        title: "问卷统计",
                        parentPath: '/business/questionnaire/list',
                        operate: true,
                    },
                    component: () => import("@views/business/questionanwser/questionanswer-list.vue"),
                },
            ],
        },


    ],
};

export default questionnaireRouter;
